import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';

declare global {
  interface String {
    $piece(string: string, postition: number) : string;
    $len(parameter: string): number;
  }
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
